var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-file-button"},[_c('el-button',_vm._b({on:{"click":_vm.handleOpenChooseFile}},'el-button',_vm.$props,false),[_vm._v(_vm._s(_vm.title)+" ")]),_c('input',{ref:"fileinput",staticStyle:{"display":"none"},attrs:{"type":"file","id":_vm.fileInputId,"accept":_vm.accept},on:{"change":_vm.handleChoosedFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }